export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'vehicle/SET_VEHICLE_INFO' && mutation.payload) {
      // Set a vehicle price & mileage and condition
      const { purchasePrice, mileage, condition } = state.route.query;

      // Clean price of commas and $ symbols
      const price = purchasePrice?.replace(/[$,]/g, '');

      // If vehicle found, update the rest information
      store.commit('vehicle/UPDATE_VEHICLE_INFO', { price, mileage, status: condition || null });
    }
  });
};
